__webpack_require__.p = "https://gizmeon.mdc.akamaized.net/files/web/staging/nfx-template/build-v1.0.0/";